import { getFilterSettings } from '../filter-tree';
import { deleteQueryParamHistory, getUrlScheme, setPaginationSession } from '../utils/index.js';

/**
 * @type {import('./index.d').resetFilterRequest}
 */
export function resetFilterRequest(context) {
  const [, setPage] = context.useContextState('pagination ', {});
  setPage({ page: 1 });
  const { isShortenUrlParam } = getFilterSettings(context);

  deleteQueryParamHistory('page', {
    preventPushHistory: true,
    isShortenUrlParam,
    urlScheme: getUrlScheme(),
  });
  setPaginationSession(1);
  callFilterRequest(context);
}

/**
 * @type {import('./index.d').callFilterRequest}
 */
export const callFilterRequest = (context, addition) => {
  context.handler(context.getFilterApi, 'getFilterApi')(
    context.app.filterUrl,
    context.id,
    addition
  );
};
